<template>
  <div class="podcast-cover">
    <div class="opacity" />
    <img
      v-if="src"
      :src="src"
    >
  </div>
</template>

<script>
export default {
  props: {
    src: {
      type: String,
      default: () => '',
    },
  },
};
</script>

<style lang="scss" scoped>
.podcast-cover {
  width: 100%;
  height: 250px;

  position: absolute;
  left: 0;

  overflow: hidden;

  z-index: -1;

  img {
    object-fit: cover;
    width: 100%;

    // position: absolute;

    // top: 50%;
    // left: 50%;
    // transform: translateX(-50%) translateY(-50%);
  }

  @media (max-width: 1023px) {
    height: 185px;
  }

  @media (max-width: 767px) {
    height: 100%;

    img {
      width: auto;
      height: 100%;
    }
  }

  .opacity {
    position: absolute;
    top: 0;
    left: 0;

    height: 100%;
    width: 100%;

    background-color: rgba(0, 0, 0, .80);
  }
}
</style>



// WEBPACK FOOTER //
// app/src/components/PodcastCover.vue